export const APP_NAME = 'Recipes';

export const routes = {
  edit: '/admin/edit',
  view: '/recipes',
} as const;
